<template>
    <span class="vat small text-muted">
        {{ $translate("Ceres::Template.singleItemFootnote1") }} {{ $translate("Ceres::Template.singleItemInclVAT") }}{{  $translate("Ceres::Template.singleItemExclusive") }}
        <a @click="getShippingInfo()" data-toggle="modal" href="#shippingscosts" :title="$translate('Ceres::Template.singleItemShippingCosts')">
        {{ $translate("Ceres::Template.singleItemShippingCosts") }}
        </a>
    </span>
</template>
<script>
const ApiService = require("../../services/ApiService");

export default{
    name: "shipping-vat-info",

    methods:
    {
        getShippingInfo()
        {
          const shippingCatId = App.config.global.shippingCostsCategoryId;
          ApiService.get("/ks/categorydescription/"+shippingCatId,{}, {dataType: "html", headers: { "Accept": "text/html; charset=utf-8"} })
              .done(response =>
              {
                $(".shipping-modal-body").html(response);
              });
        }
    }
}
</script>
